<template>
  <div class="salary-page">
    <!-- 统计卡片 -->
    <div class="statistics-cards">
      <div class="stat-card">
        <div class="stat-label">本月工资总额</div>
        <div class="stat-value">{{ formatMoney(statistics.currentMonthTotal) }}</div>
      </div>
      <div class="stat-card">
        <div class="stat-label">员工人数</div>
        <div class="stat-value">{{ statistics.employeeCount }}人</div>
      </div>
      <div class="stat-card">
        <div class="stat-label">人均工资</div>
        <div class="stat-value">{{ formatMoney(averageSalary) }}</div>
      </div>
    </div>

    <div class="toolbar">
      <Button color="primary" @click="openCreate">新增工资单</Button>
      <Button @click="load">刷新</Button>
    </div>

    <Table :datas="list" :loading="loading">
      <TableItem title="工资月份" prop="salaryMonth" align="center" :width="100"></TableItem>
      <TableItem title="员工编号" prop="employeeNo" align="center" :width="100"></TableItem>
      <TableItem title="员工姓名" prop="employeeName" align="center" :width="100"></TableItem>
      <TableItem title="部门" prop="department" align="center" :width="120"></TableItem>
      <TableItem title="应发工资" align="right" :width="120">
        <template slot-scope="{data}">
          {{ formatMoney(data.grossSalary) }}
        </template>
      </TableItem>
      <TableItem title="扣款合计" align="right" :width="120">
        <template slot-scope="{data}">
          {{ formatMoney(data.totalDeduction) }}
        </template>
      </TableItem>
      <TableItem title="实发工资" align="right" :width="120">
        <template slot-scope="{data}">
          <strong style="color: #1890ff;">{{ formatMoney(data.netSalary) }}</strong>
        </template>
      </TableItem>
      <TableItem title="状态" align="center" :width="80">
        <template slot-scope="{data}">
          <span :class="'status-' + data.status">{{ getStatusText(data.status) }}</span>
        </template>
      </TableItem>
      <TableItem title="操作" align="center" :width="150">
        <template slot-scope="{data}">
          <Button text size="xs" @click="openEdit(data)">编辑</Button>
          <Button text size="xs" color="green" @click="paySalary(data)" v-if="data.status === 0">发放</Button>
          <Button text size="xs" color="red" @click="remove(data)">删除</Button>
        </template>
      </TableItem>
    </Table>

    <!-- 新增/编辑弹窗 -->
    <Modal v-model="showModal" :hasCloseIcon="true" :width="900">
      <div class="modal-header">
        <div class="modal-title">{{ isEdit ? '编辑工资单' : '新增工资单' }}</div>
        <div class="modal-subtitle">{{ isEdit ? '修改工资单信息' : '录入新的工资单信息' }}</div>
      </div>
      <Form ref="form" :model="form" :rules="rules" labelPosition="left" :labelWidth="130">
        <div class="form-section">
          <div class="section-title">基本信息</div>
          <div class="form-row">
            <FormItem label="工资月份" prop="salaryMonth" class="form-col">
              <input type="month" v-model="form.salaryMonth" placeholder="请选择工资月份" style="width: 100%; height: 36px; padding: 0 10px; border: 1px solid #d9d9d9; border-radius: 4px;" />
            </FormItem>
            <FormItem label="员工编号" prop="employeeNo" class="form-col">
              <input type="text" v-model="form.employeeNo" placeholder="请输入员工编号" style="width: 100%; height: 36px; padding: 0 10px; border: 1px solid #d9d9d9; border-radius: 4px;" />
            </FormItem>
          </div>
          <div class="form-row">
            <FormItem label="员工姓名" prop="employeeName" class="form-col">
              <input type="text" v-model="form.employeeName" placeholder="请输入员工姓名" style="width: 100%; height: 36px; padding: 0 10px; border: 1px solid #d9d9d9; border-radius: 4px;" />
            </FormItem>
            <FormItem label="所属部门" class="form-col">
              <input type="text" v-model="form.department" placeholder="请输入所属部门" style="width: 100%; height: 36px; padding: 0 10px; border: 1px solid #d9d9d9; border-radius: 4px;" />
            </FormItem>
          </div>
        </div>

        <div class="form-section">
          <div class="section-title">应发工资</div>
          <div class="form-row">
            <FormItem label="基本工资" class="form-col">
              <input type="number" v-model="form.basicSalary" @input="onSalaryInput" placeholder="请输入基本工资" style="width: 100%; height: 36px; padding: 0 10px; border: 1px solid #d9d9d9; border-radius: 4px;" />
            </FormItem>
            <FormItem label="岗位津贴" class="form-col">
              <input type="number" v-model="form.positionAllowance" @input="onSalaryInput" placeholder="请输入岗位津贴" style="width: 100%; height: 36px; padding: 0 10px; border: 1px solid #d9d9d9; border-radius: 4px;" />
            </FormItem>
          </div>
          <div class="form-row">
            <FormItem label="绩效奖金" class="form-col">
              <input type="number" v-model="form.performanceBonus" @input="onSalaryInput" placeholder="请输入绩效奖金" style="width: 100%; height: 36px; padding: 0 10px; border: 1px solid #d9d9d9; border-radius: 4px;" />
            </FormItem>
            <FormItem label="加班工资" class="form-col">
              <input type="number" v-model="form.overtimePay" @input="onSalaryInput" placeholder="请输入加班工资" style="width: 100%; height: 36px; padding: 0 10px; border: 1px solid #d9d9d9; border-radius: 4px;" />
            </FormItem>
          </div>
          <div class="form-row">
            <FormItem label="其他补贴" class="form-col">
              <input type="number" v-model="form.otherAllowance" @input="onSalaryInput" placeholder="请输入其他补贴" style="width: 100%; height: 36px; padding: 0 10px; border: 1px solid #d9d9d9; border-radius: 4px;" />
            </FormItem>
            <FormItem label="应发合计" class="form-col">
              <input type="number" :value="displayGrossSalary" readonly placeholder="自动计算" style="width: 100%; height: 36px; padding: 0 10px; border: 1px solid #d9d9d9; border-radius: 4px; background: #f5f5f5; font-weight: bold; color: #1890ff;" />
            </FormItem>
          </div>
        </div>

        <div class="form-section">
          <div class="section-title">扣款项</div>
          <div class="form-row">
            <FormItem label="养老保险" class="form-col">
              <input type="number" v-model="form.pensionInsurance" @input="onSalaryInput" placeholder="请输入养老保险" style="width: 100%; height: 36px; padding: 0 10px; border: 1px solid #d9d9d9; border-radius: 4px;" />
            </FormItem>
            <FormItem label="医疗保险" class="form-col">
              <input type="number" v-model="form.medicalInsurance" @input="onSalaryInput" placeholder="请输入医疗保险" style="width: 100%; height: 36px; padding: 0 10px; border: 1px solid #d9d9d9; border-radius: 4px;" />
            </FormItem>
          </div>
          <div class="form-row">
            <FormItem label="失业保险" class="form-col">
              <input type="number" v-model="form.unemploymentInsurance" @input="onSalaryInput" placeholder="请输入失业保险" style="width: 100%; height: 36px; padding: 0 10px; border: 1px solid #d9d9d9; border-radius: 4px;" />
            </FormItem>
            <FormItem label="住房公积金" class="form-col">
              <input type="number" v-model="form.housingFund" @input="onSalaryInput" placeholder="请输入住房公积金" style="width: 100%; height: 36px; padding: 0 10px; border: 1px solid #d9d9d9; border-radius: 4px;" />
            </FormItem>
          </div>
          <div class="form-row">
            <FormItem label="个人所得税" class="form-col">
              <input type="number" v-model="form.personalTax" @input="onSalaryInput" placeholder="请输入个人所得税" style="width: 100%; height: 36px; padding: 0 10px; border: 1px solid #d9d9d9; border-radius: 4px;" />
            </FormItem>
            <FormItem label="其他扣款" class="form-col">
              <input type="number" v-model="form.otherDeduction" @input="onSalaryInput" placeholder="请输入其他扣款" style="width: 100%; height: 36px; padding: 0 10px; border: 1px solid #d9d9d9; border-radius: 4px;" />
            </FormItem>
          </div>
        </div>

        <div class="form-section">
          <div class="section-title">实发工资</div>
          <div class="form-row">
            <FormItem label="实发工资" class="form-col">
              <input type="number" :value="displayNetSalary" readonly placeholder="自动计算" style="width: 100%; height: 36px; padding: 0 10px; border: 1px solid #d9d9d9; border-radius: 4px; background: #e6f7ff; font-weight: bold; color: #1890ff;" />
            </FormItem>
            <FormItem label="备注" class="form-col">
              <input type="text" v-model="form.remark" placeholder="请输入备注" style="width: 100%; height: 36px; padding: 0 10px; border: 1px solid #d9d9d9; border-radius: 4px;" />
            </FormItem>
          </div>
        </div>
      </Form>
      <div slot="footer">
        <Button color="primary" @click="save" size="l">保存</Button>
        <Button @click="showModal = false" size="l">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import salaryApi from '../../api/salary';

export default {
  name: 'Salary',
  data() {
    return {
      list: [],
      loading: false,
      statistics: { byMonth: [], currentMonthTotal: 0, employeeCount: 0 },
      showModal: false,
      isEdit: false,
      form: {
        salaryMonth: '',
        employeeNo: '',
        employeeName: '',
        department: '',
        basicSalary: null,
        positionAllowance: null,
        performanceBonus: null,
        overtimePay: null,
        otherAllowance: null,
        pensionInsurance: null,
        medicalInsurance: null,
        unemploymentInsurance: null,
        housingFund: null,
        personalTax: null,
        otherDeduction: null,
        remark: ''
      },
      rules: {
        salaryMonth: [{ required: true, message: '请输入工资月份' }],
        employeeNo: [{ required: true, message: '请输入员工编号' }],
        employeeName: [{ required: true, message: '请输入员工姓名' }]
      }
    };
  },
  computed: {
    displayGrossSalary() {
      const total = 
        (parseFloat(this.form.basicSalary) || 0) +
        (parseFloat(this.form.positionAllowance) || 0) +
        (parseFloat(this.form.performanceBonus) || 0) +
        (parseFloat(this.form.overtimePay) || 0) +
        (parseFloat(this.form.otherAllowance) || 0);
      return total;
    },
    displayNetSalary() {
      const deduction = 
        (parseFloat(this.form.pensionInsurance) || 0) +
        (parseFloat(this.form.medicalInsurance) || 0) +
        (parseFloat(this.form.unemploymentInsurance) || 0) +
        (parseFloat(this.form.housingFund) || 0) +
        (parseFloat(this.form.personalTax) || 0) +
        (parseFloat(this.form.otherDeduction) || 0);
      return this.displayGrossSalary - deduction;
    },
    averageSalary() {
      if (!this.statistics.employeeCount || this.statistics.employeeCount === 0) return 0;
      return (this.statistics.currentMonthTotal || 0) / this.statistics.employeeCount;
    }
  },
  mounted() {
    this.load();
    this.loadStatistics();
    this.initSalaryMonth();
  },
  methods: {
    initSalaryMonth() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      this.form.salaryMonth = `${year}-${month}`;
    },
    async load() {
      this.loading = true;
      try {
        const res = await salaryApi.getSalaries();
        this.list = res.data || [];
      } finally {
        this.loading = false;
      }
    },
    async loadStatistics() {
      try {
        const res = await salaryApi.getSalaryStatistics();
        this.statistics = res.data || { byMonth: [], currentMonthTotal: 0, employeeCount: 0 };
      } catch (e) {
        console.error('加载统计失败', e);
      }
    },
    openCreate() {
      this.isEdit = false;
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      this.form = {
        salaryMonth: `${year}-${month}`,
        employeeNo: '',
        employeeName: '',
        department: '',
        basicSalary: null,
        positionAllowance: null,
        performanceBonus: null,
        overtimePay: null,
        otherAllowance: null,
        pensionInsurance: null,
        medicalInsurance: null,
        unemploymentInsurance: null,
        housingFund: null,
        personalTax: null,
        otherDeduction: null,
        remark: ''
      };
      this.showModal = true;
    },
    openEdit(data) {
      this.isEdit = true;
      this.form = { ...data };
      this.showModal = true;
    },
    onSalaryInput() {
      // 输入时实时更新计算值到 form，用于保存
      this.form.grossSalary = this.displayGrossSalary;
      this.form.totalDeduction = 
        (parseFloat(this.form.pensionInsurance) || 0) +
        (parseFloat(this.form.medicalInsurance) || 0) +
        (parseFloat(this.form.unemploymentInsurance) || 0) +
        (parseFloat(this.form.housingFund) || 0) +
        (parseFloat(this.form.personalTax) || 0) +
        (parseFloat(this.form.otherDeduction) || 0);
      this.form.netSalary = this.displayNetSalary;
    },
    async save() {
      const valid = await this.$refs.form.valid();
      if (!valid) return;

      // 确保计算值已更新
      this.onSalaryInput();

      try {
        if (this.isEdit) {
          await salaryApi.updateSalary(this.form.id, this.form);
        } else {
          await salaryApi.createSalary(this.form);
        }
        this.showModal = false;
        this.$Message.success('保存成功');
        this.load();
        this.loadStatistics();
      } catch (e) {
        this.$Message.error(e.msg || '保存失败');
      }
    },
    async paySalary(data) {
      if (!confirm(`确认发放 ${data.employeeName} ${data.salaryMonth} 的工资？`)) return;
      try {
        await salaryApi.paySalary(data.id);
        this.$Message.success('发放成功');
        this.load();
        this.loadStatistics();
      } catch (e) {
        this.$Message.error(e.msg || '发放失败');
      }
    },
    async remove(data) {
      if (!confirm(`确认删除 ${data.employeeName} ${data.salaryMonth} 的工资单？此操作不可恢复！`)) return;
      try {
        await salaryApi.deleteSalary(data.id);
        this.$Message.success('删除成功');
        this.load();
        this.loadStatistics();
      } catch (e) {
        this.$Message.error(e.msg || '删除失败');
      }
    },
    getStatusText(status) {
      const map = { 0: '未发放', 1: '已发放' };
      return map[status] || '未知';
    },
    formatMoney(value) {
      if (value === null || value === undefined) return '0.00';
      return parseFloat(value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }
};
</script>

<style scoped>
.salary-page {
  padding: 20px;
}
.toolbar {
  margin-bottom: 16px;
}
.toolbar button {
  margin-right: 8px;
}
.statistics-cards {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
}
.stat-card {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  text-align: center;
}
.stat-label {
  color: #666;
  font-size: 14px;
  margin-bottom: 8px;
}
.stat-value {
  color: #1890ff;
  font-size: 24px;
  font-weight: 600;
}
.status-0 { color: #faad14; }
.status-1 { color: #52c41a; }

/* 弹窗头部标题 */
.modal-header {
  margin: -20px -20px 20px -20px;
  padding: 20px 24px;
  background: linear-gradient(135deg, #1890ff 0%, #36cfc9 100%);
  border-radius: 4px 4px 0 0;
}
.modal-title {
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 4px;
}
.modal-subtitle {
  font-size: 13px;
  color: rgba(255,255,255,0.85);
}

/* 表单分区 */
.form-section {
  margin-bottom: 20px;
  padding: 16px;
  background: #fafafa;
  border-radius: 4px;
}
.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e8e8e8;
}

/* 双列表单布局 */
.form-row {
  display: flex;
  gap: 24px;
  margin-bottom: 16px;
}
.form-col {
  flex: 1;
  margin-bottom: 0;
}
.form-col :deep(.h-form-item-label) {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}
.form-col :deep(.h-input),
.form-col :deep(.h-select) {
  width: 100%;
  height: 36px;
  font-size: 14px;
}
.form-col :deep(.h-input input),
.form-col :deep(.h-select-value) {
  font-size: 14px;
}
</style>
